/**
 * Data comes from https://docs.google.com/spreadsheets/d/12q4bcOhY_xm0oKO9fC6Dd2LsBEreejE0c6H5zdjyKKk
 *
 * To generate the EXTRA_CUSTOMIZATION_COLORS array from the spreadsheet, do the following:
 * - On the spreadsheet, click File => Download => Comma Separated Values (.csv)
 * - Run the .csv file through https://csvjson.com/csv2json
 * - Copy the resulting array
 * - In a browser console, run...
 *   <PASTE_ARRAY_HERE>.filter(c => !!c['Swatch Order']).map(c => ({ value: `${c.HEX}`, label: c.Name }));
 * - Copy the resulting array and paste it below
 */

export const EXTRA_CUSTOMIZATION_COLORS = [
  {
    value: '000000',
    label: 'Black',
  },
  {
    value: 'ffffff',
    label: 'White',
  },
  {
    value: 'fefcf0',
    label: 'Light Butter',
  },
  {
    value: 'fef7df',
    label: 'Cream',
  },
  {
    value: 'fffed5',
    label: 'Butter',
  },
  {
    value: 'ffcd80',
    label: 'Honey',
  },
  {
    value: 'ffd0a8',
    label: 'Peach',
  },
  {
    value: 'f8a082',
    label: 'Salmon',
  },
  {
    value: 'd86850',
    label: 'Burnt Orange',
  },
  {
    value: 'c64527',
    label: 'Deep Orange',
  },
  {
    value: 'eb442a',
    label: 'Tomato',
  },
  {
    value: 'de6136',
    label: 'Orange',
  },
  {
    value: 'f9e1de',
    label: 'Blush',
  },
  {
    value: 'f8c6b8',
    label: 'Peach Blush',
  },
  {
    value: 'f27f81',
    label: 'Coral',
  },
  {
    value: 'f26555',
    label: 'Bright Coral',
  },
  {
    value: 'ee4258',
    label: 'Crimson',
  },
  {
    value: 'd53839',
    label: 'Red',
  },
  {
    value: 'ece1e1',
    label: 'Light Mauve',
  },
  {
    value: 'fee9ee',
    label: 'Light Pink',
  },
  {
    value: 'fde3e2',
    label: 'Soft Pink',
  },
  {
    value: 'e7b6b1',
    label: 'Dusty Peach',
  },
  {
    value: 'bd989f',
    label: 'Dusty Rose',
  },
  {
    value: 'd8a2ab',
    label: 'Dusty Pink',
  },
  {
    value: 'f6ebff',
    label: 'Light Lilac',
  },
  {
    value: 'e9dfec',
    label: 'Light Lavender',
  },
  {
    value: 'c1afc4',
    label: 'Lilac',
  },
  {
    value: 'dbd1e9',
    label: 'Lavender',
  },
  {
    value: 'b2a6d7',
    label: 'Purple',
  },
  {
    value: '5154a3',
    label: 'Indigo',
  },
  {
    value: 'eaf2fb',
    label: 'Light Sky',
  },
  {
    value: 'd7e6fc',
    label: 'Pale Blue',
  },
  {
    value: 'c4d6e0',
    label: 'Baby Blue',
  },
  {
    value: '65b2e8',
    label: 'Dark Sky',
  },
  {
    value: '8cabc0',
    label: 'Dusty Blue',
  },
  {
    value: '3e8ad0',
    label: 'Blue',
  },
  {
    value: 'f1f5f6',
    label: 'Mist',
  },
  {
    value: 'e2e9ed',
    label: 'Ice',
  },
  {
    value: 'e1f0e7',
    label: 'Mint',
  },
  {
    value: '95c9b1',
    label: 'Seafoam',
  },
  {
    value: 'c6dee0',
    label: 'Iceberg',
  },
  {
    value: 'aac8cb',
    label: 'Light Teal',
  },
  {
    value: 'e2f0d3',
    label: 'Light Green',
  },
  {
    value: '93bf45',
    label: 'Apple',
  },
  {
    value: 'a7c38d',
    label: 'Pistachio',
  },
  {
    value: '839c7a',
    label: 'Bright Sage',
  },
  {
    value: '6d9f7b',
    label: 'Green',
  },
  {
    value: '4a5e43',
    label: 'Dark Olive',
  },
  {
    value: 'e1e5da',
    label: 'Lightest Green',
  },
  {
    value: 'cfdbcd',
    label: 'Light Sage',
  },
  {
    value: '96a497',
    label: 'Sage',
  },
  {
    value: '717769',
    label: 'Dark Sage',
  },
  {
    value: '605b48',
    label: 'Dark Khaki',
  },
  {
    value: '62494a',
    label: 'Chocolate',
  },
  {
    value: 'fcf8f5',
    label: 'Off-White',
  },
  {
    value: 'f5efe8',
    label: 'Linen',
  },
  {
    value: 'f0d8bf',
    label: 'Beige',
  },
  {
    value: 'c1ad91',
    label: 'Tan',
  },
  {
    value: 'b2896f',
    label: 'Camel',
  },
  {
    value: '8d7873',
    label: 'Taupe',
  },
  {
    value: 'f7f3f0',
    label: 'Light Oatmeal',
  },
  {
    value: 'f1f0f0',
    label: 'Smoke',
  },
  {
    value: 'e6e6e6',
    label: 'Light Gray',
  },
  {
    value: 'e2e1dc',
    label: 'Sage Mist',
  },
  {
    value: 'c5c5c5',
    label: 'Gray',
  },
  {
    value: 'bdb5af',
    label: 'Greige',
  },
  {
    value: 'ffd04b',
    label: 'Yellow',
  },
  {
    value: 'd9ad43',
    label: 'Mustard',
  },
  {
    value: 'a38341',
    label: 'Gold',
  },
  {
    value: '985e29',
    label: 'Dark Ochre',
  },
  {
    value: 'c57e2a',
    label: 'Pumpkin Spice',
  },
  {
    value: 'b35737',
    label: 'Light Rust',
  },
  {
    value: '90192c',
    label: 'Light Burgundy',
  },
  {
    value: '9f2626',
    label: 'Dark Red',
  },
  {
    value: '67121f',
    label: 'Dark Burgundy',
  },
  {
    value: '5b2525',
    label: 'Maroon',
  },
  {
    value: '844a3f',
    label: 'Brown',
  },
  {
    value: '9f3c0b',
    label: 'Dark Rust',
  },
  {
    value: 'f2aac4',
    label: 'Flamingo',
  },
  {
    value: 'c6328f',
    label: 'Fuchsia',
  },
  {
    value: '8f4d6c',
    label: 'Deep Magenta',
  },
  {
    value: '712233',
    label: 'Wine',
  },
  {
    value: '543946',
    label: 'Dark Plum',
  },
  {
    value: '462047',
    label: 'Eggplant',
  },
  {
    value: '1f51a0',
    label: 'Cobalt',
  },
  {
    value: '385482',
    label: 'Dusty Cobalt',
  },
  {
    value: '1b3069',
    label: 'Dark Royal',
  },
  {
    value: '3a547c',
    label: 'Dark Cobalt',
  },
  {
    value: '602b4a',
    label: 'Plum',
  },
  {
    value: '643768',
    label: 'Light Eggplant',
  },
  {
    value: '045a74',
    label: 'Teal Blue',
  },
  {
    value: '04727b',
    label: 'Teal',
  },
  {
    value: '1a594a',
    label: 'Emerald',
  },
  {
    value: '073533',
    label: 'Dark Emerald',
  },
  {
    value: '0f2750',
    label: 'Navy',
  },
  {
    value: '073a6e',
    label: 'Dark Blue',
  },
  {
    value: '679da8',
    label: 'Teal Ocean',
  },
  {
    value: '4b7781',
    label: 'Grayed Teal',
  },
  {
    value: '467058',
    label: 'Hunter',
  },
  {
    value: '0a3d1f',
    label: 'Forest',
  },
  {
    value: '1e352b',
    label: 'Dark Forest',
  },
  {
    value: '333b20',
    label: 'Darkest Olive',
  },
  {
    value: '656a71',
    label: 'Charcoal',
  },
  {
    value: '364251',
    label: 'Grayed Navy',
  },
  {
    value: '424242',
    label: 'Dark Charcoal',
  },
  {
    value: '282b31',
    label: 'Darkest Navy',
  },
  {
    value: '635653',
    label: 'Dark Taupe',
  },
  {
    value: '746673',
    label: 'Dusty Purple',
  },
];

export const EXTRA_CUSTOMIZATION_LABELS_BY_COLOR = EXTRA_CUSTOMIZATION_COLORS.reduce(
  (labelsByColor, color) => {
    // eslint-disable-next-line no-param-reassign
    labelsByColor[color.value] = color.label;
    return labelsByColor;
  },
  {} as Record<string, string>
);
